import script from "./HistoryFinancesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./HistoryFinancesList.vue?vue&type=script&lang=ts&setup=true"

import "./HistoryFinancesList.vue?vue&type=style&index=0&id=1c2505da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2505da"]])

export default __exports__